import logo from "./logo.svg";
import "./App.css";
import AppRoute from "./AppRoute";
import NavbarHeader from "./components/NavbarHeader";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import About from "./components/About";



function App() {
  return (
    <>
      {/* <NavbarHeader></NavbarHeader> */}
      <AppRoute></AppRoute>
      
    </>
  );
}

export default App;
